import { createEvent, createStore } from 'effector'

export const actions = {
  setFinishedEDL: createEvent<EtatDesLieuxResponse[]>('setFinishedEDL'),
  setForm: createEvent<Partial<EDLForm>>('setEDLForm'),
  resetForm: createEvent('resetEDLForm'),
  addForm: createEvent<EDLForm>('addEDLForm'),
  setForms: createEvent<EDLForm[]>('setEDLForms'),
  removeForm: createEvent<string>('removeEDLForm'),
  resetForms: createEvent('resetEDLForm'),
  reset: createEvent('reset'),
}

const initialState: EDLState = {
  form: {
    espaceIds: [],
    espacesCloturesIds: [],
    incidentAcceptIds: [],
    incidentRefuseIds: [],
    incidentOrganisateurIds: [],
    incidentViparisIds: [],
  } as unknown as EDLForm,
  forms: [],
  EDLs: [],
}

export const store = createStore<EDLState>(initialState, { name: 'edl' })
  .on(actions.setFinishedEDL, (s, EDLs) => ({ ...s, EDLs }))
  .on(actions.setForm, (s, part) => ({ ...s, form: { ...s.form, ...part } }))
  .on(actions.resetForm, (s) => ({ ...s, form: initialState.form }))
  .on(actions.addForm, (s, form) => ({ ...s, forms: [...s.forms, form] }))
  .on(actions.setForms, (s, forms) => ({ ...s, forms }))
  .on(actions.removeForm, (s, id) => ({ ...s, forms: s.forms.filter((f) => f.id !== id) }))
  .on(actions.resetForms, (s) => ({ ...s, forms: initialState.forms }))
  .reset(actions.reset)
